import { RoofFaceRecord } from "common/records/RoofFace";
import { RootState } from "common/reducers";
import { currentMeasurement } from "common/selectors/measurement.common.selectors";
import { List } from "immutable";
import { createSelector } from "reselect";

/**
 * Gets a roofFace record by the given id
 * @param { RootState } state The RootState
 * @param {{ roofFaceId: number }} props
 * @returns
 */
export const roofFace = (state: RootState, props: any) => state.getIn(["roofFaces", "byId"]).get(props.roofFaceId);

/**
 * Gets a list of roofFace records by the given ids
 * @param { RootState } state The RootState
 * @param {{ roofFaceIds: List<number> }} props
 * @returns
 */
export const roofFaces = (state: RootState, props: { roofFaceIds: List<number> }): List<RoofFaceRecord> => {
  const { roofFaceIds } = props;
  return roofFaceIds.map((id: number) => roofFace(state, { roofFaceId: id }) as RoofFaceRecord);
};

/**
 * Gets a list of roofFace records by the current measurement's roof_face_ids
 * @param { RootState } state The RootState
 * @returns {List<RoofFaceRecord>} roofFaceRecords
 */
export const currentMeasurementRoofFaces = createSelector(
  [currentMeasurement, (state: RootState) => state],
  (measurement, state) => {
    const roofFaceIds = measurement?.get("roof_face_ids") || List();
    return roofFaces(state, { roofFaceIds });
  },
);
